module.exports = {
  siteMetadata: {
    title: "Yorkshire Packaging Systems",
    description:
      "Yorkshire Packaging Systems - supplying shrink wrap machines and shrink films since 1977",
    image: "https://a.storyblok.com/f/120136/1920x860/86bc22ecac/frame-7.png",
    siteUrl: "https://www.yps.co.uk",
    noindex: "index,follow",
  },
  plugins: [
    {
      resolve: 'gatsby-plugin-load-script',
      options: {
        src: "https://plausible.io/js/script.js",
        "data-domain": "yps.co.uk",
        defer: true,
      }
    },    
    "gatsby-plugin-postcss",
    {
      resolve: "gatsby-source-storyblok",
      options: {
        accessToken: "ca3G5XZFjaSvurZqkwrqaAtt",
        homeSlug: "home",
        version: process.env.NODE_ENV === "production" ? "published" : "draft",
      },
    },
    {
      resolve: "gatsby-plugin-react-svg",
      options: {
        rule: {
          include: /images/,
        },
      },
    },
    {
      resolve: "gatsby-plugin-google-tagmanager",
      options: {
        id: "GTM-T2MK2FM",

        // Include GTM in development.
        //
        // Defaults to false meaning GTM will only be loaded in production.
        includeInDevelopment: false,

        // datalayer to be set before GTM is loaded
        // should be an object or a function that is executed in the browser
        //
        // Defaults to null
        defaultDataLayer: { platform: "gatsby" },

        // Name of the event that is triggered
        // on every Gatsby route change.
        //
        // Defaults to false
        enableWebVitalsTracking: true,
      },
    },
    {
      resolve: `gatsby-plugin-google-gtag`,
      options: {
        trackingIds: [
          "UA-43869456-1", // Google Analytics / GA
          "G-PV16NZQMZB", // GA4 measurement ID
        ],
        pluginConfig: {
          // Puts tracking script in the head instead of the body
          head: true,
        },
      },
    },
    "gatsby-plugin-root-import",
    `gatsby-plugin-sharp`,
    `gatsby-transformer-sharp`,
    `gatsby-plugin-sitemap`,
    "gatsby-plugin-react-helmet",
    {
      resolve: `gatsby-plugin-react-helmet-canonical-urls`,
      options: {
        siteUrl: `https://www.yps.co.uk`,
        noTrailingSlash: false,
      },
    },
    {
      resolve: `gatsby-plugin-breadcrumb`,
      options: {
        defaultCrumb: {
          location: {
            pathname: "/",
          },
          crumbLabel: "Home",
          crumbSeparator: " / ",
        },
        useAutoGen: true,
        trailingSlashes: true,
      },
    },
    `gatsby-plugin-force-trailing-slashes`,
  ],
};
